import './App.css';
import paises from './paises.json';
import { verificaNIF} from "./utils";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import {
    Input,
    Button, NativeSelectRoot, NativeSelectField,Field
} from "@chakra-ui/react";
import * as React from 'react'
import { useNavigate } from 'react-router-dom';
import {FormControlLabel, Radio, RadioGroup} from "@mui/material";
import { registerLocale, setDefaultLocale } from  "react-datepicker";
import { es } from 'date-fns/locale/es';

function App() {
    let navigate = useNavigate();
    const [formData, setFormData] = React.useState({"Provincia cita": ""});
    const [mandatoryFormData, setmandatoryFormData] = React.useState([]);
    const [showResidencia, setShowResidencia] = React.useState(false);
    const [allMandatoryFilled, setallMandatoryFilled] = React.useState(false);
    const [selectedCountryValue, setSelectedCountryValue] = React.useState('348');
    const [startDate, setStartDate] = React.useState(new Date());
    var current_date = new Date();
    const [endDate, setEndDate] = React.useState(new Date(current_date.getFullYear() + 1, current_date.getMonth(), current_date.getDate()));
    registerLocale('es', es)

    React.useEffect(() => {
        setPaisCanje();
    }, []);

    const decodeJwtPayload = (token) => {
        const parts = token.split(".");
        if (parts.length !== 3) {
            throw new Error("Invalid JWT format");
        }

        const payloadBase64 = parts[1];
        const decodedPayload = atob(payloadBase64);
        return JSON.parse(decodedPayload);
    };

    const setPaisCanje = async () => {
        const defaultData = {"documento": "", "nombre": "", "numero": "", "correo": "", "txtObservaciones": ""};
        const defaultMandatoryData = ["documento", "nombre", "numero", "correo", "txtObservaciones"];

        const token = searchParams.get("token")
        const payload = decodeJwtPayload(token)

        console.log(payload)

        defaultData["fechaMin"] = startDate.toLocaleDateString('en-GB')
        defaultData["fechaMax"] = endDate.toLocaleDateString('en-GB')
        defaultData["token"] = token
        defaultData["tipo_bot"] = "RC_GENCAT"
        defaultData["tipoCita"] = "RC_GENCAT"
        defaultData["pageType"] = "RC_GENCAT"
        defaultData["price"] = payload["price"]
        defaultData["tguser"] = payload["tguser_id"]
        defaultData["client_id"] = payload["tguser_id"]
        defaultData["rdbTipoDoc"] = "nie"
        defaultData["txtPaisNac"] = "350"
        defaultData["source"] = "TELEGRAM"
        defaultData["client_email"] = ""
        defaultData["timePreference"] = "any"
        defaultData["codTramite"] = payload["tramite"]
        payload["oficina"] = payload["oficina"] + "";
        defaultData["oficinas"] = payload["oficina"]
        defaultData["codOficina"] = payload["oficina"]
        setFormData(defaultData);
        setmandatoryFormData(defaultMandatoryData);
    }

    const [showNumResolucion, setShowNumResolucion] = React.useState(false);
    const [showFechaResolucion, setShowFechaResolucion] = React.useState(false);

    const handleSubmit = async () => {
        if (validateForm()) {
            // For now, just log the data. In real scenarios, you'd send this to a server.
            console.log(formData);

            fetch('https://api.notifybotstg.com/api/pro/new_appointment', {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            })
                //.then(response => response.text())
                .then(data => {
                    console.log('Success:', data);
                    navigate('success');
                })
                .catch((error) => {
                    console.error('Error:', error);
                    navigate('error');
                });
        }
    };

    const validateForm = () => {
        var fulfilled = true;
        console.log(formData)

        mandatoryFormData.forEach(field => {
            console.log(field)
            if ((formData[field] === '') || (Array.isArray(formData[field]) && formData[field].length == 0)) {
                fulfilled = false;
                console.log(formData[field])
                setallMandatoryFilled(true)
            }
        });

        fulfilled = fulfilled && (formData["rdbTipoDoc"] === "passaport" ||
                                  formData["rdbTipoDoc"] === "documentIdentitatEstranger" ||
                                  formData["rdbTipoDoc"] === "targetaSanitaria" || verificaNIF(formData["documento"]));

        return fulfilled;
    }

    const handleInputChange = (event) => {
        console.log(event)

        setFormData({
            ...formData,
            [event.target.name]: event.target.type === 'checkbox' ? event.target.checked : event.target.value.trimStart()
        });
    };

    const searchParams = new URLSearchParams(document.location.search)

    const [tipoDoc, setTipoDoc] = React.useState('nie');

    return (
        <div>
            <div className="form">
                <div className="grid-container">
                    <div key="rdbTipoDoc" className="input-wrapper">
                        <label>Tipo de documento<b style={{color: 'red'}}>{" *"}</b></label>
                        <RadioGroup
                            name="rdbTipoDoc"
                            value={tipoDoc}
                            onChange={(newValue) => {
                                setTipoDoc(newValue.target.value)
                                formData["rdbTipoDoc"] = newValue.target.value
                            }}
                        >
                            <FormControlLabel value="nif" control={<Radio/>} label="DNI"/>
                            <FormControlLabel value="passaport" control={<Radio/>} label="Passaport"/>
                            <FormControlLabel value="nie" control={<Radio/>} label="NIE"/>
                            <FormControlLabel value="documentIdentitatEstranger" control={<Radio/>}
                                              label="Document d'identitat estranger"/>
                            <FormControlLabel value="targetaSanitaria" control={<Radio/>}
                                              label="Targeta sanitària individual"/>
                        </RadioGroup>
                    </div>
                    <div key="documento" className="input-wrapper">
                        <label>Número de documento<b style={{color: 'red'}}>{" *"}</b></label>
                        <Field.Root invalid={formData["documento"] !== undefined && !(formData["rdbTipoDoc"] === "passaport" ||
                            formData["rdbTipoDoc"] === "documentIdentitatEstranger" ||
                            formData["rdbTipoDoc"] === "targetaSanitaria" || verificaNIF(formData["documento"]))}>
                            <Input
                                name="documento"
                                type="text"
                                value={formData["documento"] || ''}
                                onChange={handleInputChange}
                                placeholder=''
                            />
                            <Field.ErrorText>Introduce un documento valido</Field.ErrorText>
                        </Field.Root>
                    </div>
                    {(formData["rdbTipoDoc"] === "passaport" || formData["rdbTipoDoc"] === "documentIdentitatEstranger") &&
                    <div id="txtPaisNac" className="input-wrapper"
                         style={{display: showResidencia ? "none" : "flex"}}>
                        <label>País de nacionalidad <b style={{color: 'red'}}> *</b></label>
                        <NativeSelectRoot size="sm" width="240px" name="txtPaisNac"
                                          value={selectedCountryValue} onChange={handleInputChange}>
                            <NativeSelectField name="txtPaisNac">
                                <option key="Seleccionar" value="Seleccionar">Seleccionar</option>
                                {paises.map(opt => (
                                    <option name="txtPaisNac" key={opt["value"]} value={opt["value"]}>{opt["text"]}</option>
                                ))}
                            </NativeSelectField>
                        </NativeSelectRoot>
                    </div>
                    }
                    <div key="nombre" className="input-wrapper">
                        <label>Nombre completo<b style={{color: 'red'}}>{" *"}</b></label>
                        <Input
                            name="nombre"
                            type="text"
                            value={formData["nombre"] || ''}
                            onChange={handleInputChange}
                            placeholder=''
                        />
                    </div>
                    <div key="numero" className="input-wrapper">
                        <label>Teléfono<b style={{color: 'red'}}>{" *"}</b></label>
                        <Field.Root invalid={formData["numero"] && (formData["numero"].length < 9 && formData["numero"].length > 0)}>
                            <Input
                                name="numero"
                                type="tel"
                                value={formData["numero"] || ''}
                                onChange={handleInputChange}
                                placeholder=''
                                minLength={9}
                                maxLength={9}
                            />
                            <Field.ErrorText>Introduce un teléfono valido</Field.ErrorText>
                        </Field.Root>
                    </div>
                    <div key="correo" className="input-wrapper">
                        <label>Correo electrónico<b style={{color: 'red'}}>{" *"}</b></label>
                        <Input
                            name="correo"
                            type="email"
                            value={formData["correo"] || ''}
                            onChange={handleInputChange}
                            placeholder=''
                        />
                    </div>
                    <div key="txtObservaciones" className="input-wrapper">
                        <label>Detalle Cita<b style={{color: 'red'}}>{" *"}</b></label>
                        <Input
                            name="txtObservaciones"
                            type="text"
                            value={formData["txtObservaciones"] || ''}
                            onChange={handleInputChange}
                            placeholder=''
                        />
                    </div>
                    <div id="fechaMin" className="input-wrapper"
                         style={{display: showResidencia ? "none" : "flex"}}>
                        <label>Buscar fecha a partir del</label>
                        <DatePicker
                            showIcon
                            selected={startDate}
                            onSelect={(date) => setStartDate(date)}
                            onChange={(date) => {
                                var event = {
                                    "target": {
                                        "name": "fechaMin",
                                        "value": date.toLocaleDateString('en-GB'),
                                        "type": "datepicker"
                                    }
                                };
                                handleInputChange(event)
                            }}
                            onChangeRaw={event => {
                                const date = moment(event.target.value, "DD/MM/YYYY");
                                if (date.isValid()) {
                                    setStartDate(date.toDate());
                                }
                            }}
                            name="fechaMin"
                            className="form-control"
                            dateFormat="dd/MM/yyyy"
                            locale="es"
                        />
                    </div>
                    <div id="fechaMax" className="input-wrapper"
                         style={{display: showResidencia ? "none" : "flex"}}>
                        <label>Hasta el día</label>
                        <DatePicker
                            showIcon
                            selected={endDate}
                            onSelect={(date) => setEndDate(date)}
                            onChange={(date) => {
                                var event = {
                                    "target": {
                                        "name": "fechaMax",
                                        "value": date.toLocaleDateString('en-GB'),
                                        "type": "datepicker"
                                    }
                                };
                                handleInputChange(event)
                            }}
                            onChangeRaw={event => {
                                const date = moment(event.target.value, "DD/MM/YYYY");
                                if (date.isValid()) {
                                    setEndDate(date.toDate());
                                }
                            }}
                            name="fechaMax"
                            className="form-control"
                            dateFormat="dd/MM/yyyy"
                            minDate={startDate}
                            locale="es"
                        />
                    </div>
                    <Button style={{width: "100%"}} class="sendButton" variant="contained" color="primary"
                            onClick={handleSubmit}
                    >Enviar solicitud</Button>

                </div>
                {allMandatoryFilled && <p>Rellena todos los campos obligatorios *</p>}
                <div></div>
            </div>
        </div>
    );
}

export default App;
